function PlayerSearch({ value, onChange }) {
  return (
    <input
      type='text'
      className='input'
      placeholder='Search players...'
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export default PlayerSearch;
